import { SubmitToSandboxSamplesFormWebComponent } from './component/SubmitToSandboxSamplesFormWebComponent';
import { WEB_COMPONENT_SUBMIT_TO_SANDBOX_SAMPLES_FORM } from '../../../../webcomponents.constants';

export { SubmitToSandboxSamplesFormWebComponent };

window.customElements.define(WEB_COMPONENT_SUBMIT_TO_SANDBOX_SAMPLES_FORM, SubmitToSandboxSamplesFormWebComponent);
